import { render } from "./PayList.vue?vue&type=template&id=4a28ce13&ts=true"
import script from "./PayList.vue?vue&type=script&lang=ts"
export * from "./PayList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__